var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "page-container onboarding-container",
      class: _vm.childClass
    },
    [
      _c("transition", { attrs: { name: "fade" } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.dataSaving || _vm.isLoading,
                expression: "dataSaving || isLoading"
              }
            ],
            staticClass: "loading-overlay",
            staticStyle: { "transition-delay": "0.3s" }
          },
          [_c("loader")],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "wtw-container full center allow-scrolling",
          class: _vm.childClass
        },
        [
          _vm.currentStep.title
            ? _c("div", { staticClass: "step-title-container" }, [
                _c("div", { staticClass: "step-title" }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.currentStep.title) +
                      "\n                "
                  ),
                  _vm.currentStep.subTitle
                    ? _c("div", { staticClass: "step-subtitle" }, [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.currentStep.subTitle) +
                            "\n                "
                        )
                      ])
                    : _vm._e()
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.currentStep.type
            ? _c("step-" + _vm.currentStep.type, {
                key: _vm.currentStep.token,
                tag: "component",
                class: {
                  "no-skip-message-padding": _vm.noSkipMessage,
                  "is-loading": _vm.isLoading
                },
                attrs: {
                  options: _vm.currentStep.options.product_option_values,
                  sendOptions: _vm.sendOptions,
                  optionsAll: _vm.currentStep.options,
                  errorMessage: _vm.errorMessage,
                  optionsSelected: _vm.userOptionValues,
                  riskValueSelected: _vm.userRiskValue,
                  extraData: _vm.currentStep.extraData
                }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "bottom-nav" }, [
        _c(
          "div",
          {
            staticClass: "next-button full",
            class: { "no-skip-message": _vm.noSkipMessage }
          },
          [
            _c("div", { staticClass: "wtw-container" }, [
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.noSkipMessage,
                      expression: "noSkipMessage"
                    }
                  ],
                  staticClass: "error-message"
                },
                [_vm._v(_vm._s(_vm.noSkipMessage))]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "button pink full-width small-font",
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.nextStepWithSave.apply(null, arguments)
                    }
                  }
                },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.currentStep.nextBtnTitle || "Next") +
                      "\n                "
                  )
                ]
              )
            ])
          ]
        ),
        _vm._v(" "),
        _vm.currentStep.noSkip
          ? _c("div", { staticClass: "back-button" }, [
              _c(
                "div",
                {
                  staticClass: "button column small-font",
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.prevStep.apply(null, arguments)
                    }
                  }
                },
                [
                  _c("img", { attrs: { src: _vm.imageUrl("back.svg") } }),
                  _vm._v(" Back\n            ")
                ]
              )
            ])
          : !_vm.currentStep.isForm && !_vm.currentStep.noSkip
          ? _c("div", { staticClass: "skip-back-buttons" }, [
              _c(
                "div",
                {
                  staticClass: "button column small-font",
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.prevStep.apply(null, arguments)
                    }
                  }
                },
                [
                  _c("img", { attrs: { src: _vm.imageUrl("back.svg") } }),
                  _vm._v(" Back\n            ")
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "button column small-font",
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.nextStep.apply(null, arguments)
                    }
                  }
                },
                [
                  _vm._v("\n                Skip "),
                  _c("img", { attrs: { src: _vm.imageUrl("forward.svg") } })
                ]
              )
            ])
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7751c740", { render: render, staticRenderFns: staticRenderFns })
  }
}